<template>
  <header class="app-header navbar">
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="mobileSidebarToggle"
    >
      &#9776;
    </button>
    <b-link
      class="navbar-brand"
      to="/"
    >
      {{ $config_appName }}<br>
      <small>Admin panel</small>
    </b-link>
    <button
      class="navbar-toggler sidebar-toggler d-md-down-none"
      type="button"
      @click="sidebarMinimize"
    >
      &#9776;
    </button>
    <div>
      <ui-breadcrumbs :list="breadcrumbs()" />
    </div>
    <b-nav
      class="ml-auto"
      style="margin-right: 10px;"
    >
      <b-navbar-nav>
        
        <b-nav-item-dropdown id="notification">
          
          <template slot="button-content">
            <i class="fa fa-bell d-flex align-items-center justify-content-center bg-white rounded-circle shadow-sm mx-1 mx-lg-2 w-40px h-40px position-relative link-secondary">

              <span class="position-absolute top-0 start-100 rounded-pill text-bg-danger">
                            {{unreadNotificationCount}}
                        </span>
            </i>
            
            
          </template>
            <li class="nav-item dropdown">
                <div class="dropdown-menu p-0 show"  aria-labelledby="notificationDropdown"  data-bs-popper="static" style="width:250px !important">
                  <div class="px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
                    <p class="font-weight-bold">Notifications</p>
                    <a href="javascript:;" class="text-muted pb-3 text-list underline cursor-pointer" v-if="newNotifications.length > 0" @click="hideNotifications">Mark all as read</a>
                  </div>
                  <div class="p-1 flex justify-content-between custombar2 scroll-panel-new" >
                    <div v-if="newNotifications.length > 0">
                      <div class="p-1 dropdown-item d-flex align-items-center py-2 scrollable-content" >
                        <div class="p-1" v-for="notification in newNotifications" :key="notification" >
                          <div class="flex-grow-1 me-2">
                            <span class="notification-title notification-message-color ">{{ notification.data.title }}</span>
                            <div>
                              <div> 
                                <span class="d-text notification-message-color ">{{ notification.data.message }}</span>
                              </div>
                            </div>
                            <span></span>
                            <span class="notification-message-text notification-time-color">{{
                                  formatDate(notification.updated_at) }}</span>
                            <span class="notification-message-text notification-time-color pt-1 pl-2 float-right">{{
                                formatDateCreated(notification.created_at) }}</span>  
                          </div>
                        </div>            
                      </div>  
                    </div>
                    <div v-else-if="notifications.length > 0">
                      <div class="dropdown-item d-flex align-items-center py-2 scrollable-content" v-for="notification in notifications" :key="notification" >
                        <div class="flex-grow-1 me-2">
                          <span class="notification-title notification-message-color ">{{ notification.data.title }}</span>
                          <div>
                            <div> 
                              <span class="d-text notification-message-color ">{{ notification.data.message }}</span>
                            </div>
                          </div>
                          <span></span>
                          <span class="notification-message-text notification-time-color">{{
                                formatDate(notification.updated_at) }}</span>
                          <span class="notification-message-text notification-time-color pt-1 pl-2 float-right">{{
                              formatDateCreated(notification.created_at) }}</span>  
                        </div> 
                      </div>
                    </div>
                    <div class="dropdown-item d-flex align-items-center py-2 scrollable-content" v-else>
                      <div class="flex-grow-1 me-2">
                        <span class="notification-title notification-message-color ">{{ 'No new notifcations' }}</span>

                      </div>
                    </div> 
                  </div>
                  <div
                    class="px-3 py-2 d-flex align-items-center justify-content-center border-top"
                  >
                    <a href="javascript:;">View all</a>
                  </div>
                </div>
            </li>
          
        </b-nav-item-dropdown>
        

        <b-nav-item-dropdown right>
          
          <template slot="button-content">
            <img
              :src="'https://www.gravatar.com/avatar/' + gravatarHash"
              class="img-avatar"
            >
            <span class="d-md-down-none">{{ username }}</span>
          </template>
          <b-dropdown-item  @click="userLogout()">
            <i class="fa fa-lock" /> {{ $t('Logout') }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      
    </b-nav>
  </header>
</template>
<script>
import MD5 from 'blueimp-md5';
import SidebarStateStorage from '../storage/SidebarStateStorage';
import UserNotificationService from "../services/UserNotificationService";
import moment from 'moment';

export default {
  name: 'AppHeader',
  data() {
    return {
      show:false,
      notifications: [],
      newNotifications: [],
      isNotification: false,
      unreadNotificationCount: '',
      loading:false
    }
  },
  computed: {
    gravatarHash() {
      if (this.user() !== null) {
        return MD5(this.user().email);
      }
      return '';
    },
  },
  watch: {
    $route() {
      this.updateTitle();
    },
  },
  mounted() {
    this.updateTitle();
    this.userNotification();
  },
  methods: {
    clickTostShow(){
      this.show = true;
     
    },
    userNotification() {
      this.loading = true;

      UserNotificationService.findAll()
        .then((response) => {
          this.loading = false;


          this.isNotification = true
          let unreadCount = '';
          let newNotificationsList = [];
          let notifications = []
          for (const notification of response) {
            if (notification.read_at === null) {
              unreadCount++;
              newNotificationsList.push(notification); // Store the new unread notifications
            }
            else {
              notifications.push(notification)
            }
          }
          this.unreadNotificationCount = unreadCount;
          this.newNotifications = newNotificationsList;
          this.notifications = notifications
        })
        .catch(() => {
          this.loading = false;

        });
      },
    
      formatDate(notificationdate) {
      const date = moment(notificationdate);
      return date.fromNow();
    },
    formatDateCreated(notificationdate) {
      const date = moment(notificationdate).format('MM-DD-YYYY');
      return date;
    },
    hideNotifications() {

        UserNotificationService.readNotifications()
          .then(() => {
            this.userNotification();
            // this.$refs.op.hide(event);
            // this.viewLess()

          })
          .catch(() => {
            // this.loading = false;

          });
        },
    clickTosthide(){
      this.show = false;
    },
    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize(e) {
      e.preventDefault();
      const result = document.getElementById('app').classList.toggle('sidebar-minimized');
      SidebarStateStorage.set(!result);
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    breadcrumbs() {
      const breadcrumbs = [];
      // eslint-disable-next-line
      for (const key in this.$route.matched) {
        const item = this.$route.matched[key];
        if ((item.meta !== undefined && item.meta.breadcrumbs !== undefined)) {
          let title = typeof item.meta.breadcrumbs === 'function' ? item.meta.breadcrumbs() : item.meta.breadcrumbs;
          if (!title.match(/^\d+$/)) {
            title = this.$t(`Breadcrumbs_${title}`);
          }
          breadcrumbs.push({
            title,
            name: typeof item.meta.breadcrumbsAlias !== 'undefined' ? item.meta.breadcrumbsAlias : item.name,
          });
        }
      }
      return breadcrumbs;
    },
    updateTitle() {
      document.title = this.breadcrumbs().map(e => e.title).reverse().join(' / ');
    },
  },
};
</script>